// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__27T8M","content":"ManualTimeModal_content__3dy2F"};